'use es6';

import { createTreatmentsResolver } from 'laboratory-lib/core/resolvers';
import { createExposureLogger } from 'laboratory-lib/core/loggers';
import { validateHttp, validateSearch, validateStore, validateTimeout, validateTreatmentsSchema, validateQuickFetch, validateQuickFetchLabel } from 'laboratory-lib/core/validators';
var mockHttpClient = {
  get: function get() {
    return new Promise(function (onSuccess, onError) {
      return onError(new Error('no http client implemented'));
    });
  },
  post: function post() {
    return new Promise(function (onSuccess, onError) {
      return onError(new Error('no http client implemented'));
    });
  }
};

function isPromise(thing) {
  return thing && typeof thing.then === 'function' && typeof thing.catch === 'function';
}

function promisify(thing) {
  if (isPromise(thing)) {
    return thing;
  }

  return new Promise(function (onComplete) {
    return onComplete(thing);
  });
}

function adaptAsyncStore(store) {
  var asyncStore;
  return function (method) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!store) return promisify();

    if (!asyncStore && typeof store.open === 'function') {
      try {
        asyncStore = store.open();
      } catch (err) {
        asyncStore = promisify();
      }
    }

    return new Promise(function (onSuccess) {
      var storeTimeout = setTimeout(function () {
        onSuccess(promisify());
      }, 1000);
      asyncStore.then(function (openStore) {
        clearTimeout(storeTimeout);

        if (!openStore) {
          onSuccess(promisify());
        } else {
          onSuccess(promisify(openStore[method].apply(openStore, args)));
        }
      }).catch(function () {
        clearTimeout(storeTimeout);
        onSuccess(promisify());
      });
    });
  };
}

function validateClientInputs(_ref) {
  var http = _ref.http,
      quickFetch = _ref.quickFetch,
      quickFetchLabel = _ref.quickFetchLabel,
      search = _ref.search,
      store = _ref.store,
      timeout = _ref.timeout,
      treatments = _ref.treatments;
  validateHttp(http, 'createClient');
  validateSearch(search, 'createClient');
  validateStore(store, 'createClient');
  validateTimeout(timeout, 'createClient');
  validateTreatmentsSchema(treatments, 'createClient');

  if (quickFetchLabel) {
    validateQuickFetch(quickFetch, 'createClient');
    validateQuickFetchLabel(quickFetchLabel, 'createClient');
  }
}

export function createClient() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$apiDomain = _ref2.apiDomain,
      apiDomain = _ref2$apiDomain === void 0 ? '' : _ref2$apiDomain,
      _ref2$ceid = _ref2.ceid,
      ceid = _ref2$ceid === void 0 ? '' : _ref2$ceid,
      _ref2$http = _ref2.http,
      http = _ref2$http === void 0 ? mockHttpClient : _ref2$http,
      _ref2$onError = _ref2.onError,
      onError = _ref2$onError === void 0 ? function () {} : _ref2$onError,
      _ref2$search = _ref2.search,
      search = _ref2$search === void 0 ? window.location.search : _ref2$search,
      _ref2$store = _ref2.store,
      store = _ref2$store === void 0 ? null : _ref2$store,
      _ref2$quickFetch = _ref2.quickFetch,
      quickFetch = _ref2$quickFetch === void 0 ? null : _ref2$quickFetch,
      _ref2$quickFetchLabel = _ref2.quickFetchLabel,
      quickFetchLabel = _ref2$quickFetchLabel === void 0 ? '' : _ref2$quickFetchLabel,
      _ref2$timeout = _ref2.timeout,
      timeout = _ref2$timeout === void 0 ? 0 : _ref2$timeout,
      _ref2$treatments = _ref2.treatments,
      treatments = _ref2$treatments === void 0 ? {} : _ref2$treatments;

  // throws runtime exceptions
  validateClientInputs({
    http: http,
    quickFetch: quickFetch,
    quickFetchLabel: quickFetchLabel,
    search: search,
    store: store,
    timeout: timeout,
    treatments: treatments
  });
  var schema = treatments;
  var asyncStore = store ? adaptAsyncStore(store) : undefined;

  var _createTreatmentsReso = createTreatmentsResolver({
    asyncStore: asyncStore,
    apiDomain: apiDomain,
    ceid: ceid,
    http: http,
    onError: onError,
    quickFetch: quickFetch,
    quickFetchLabel: quickFetchLabel,
    schema: schema,
    search: search,
    timeout: timeout
  }),
      resolveTreatments = _createTreatmentsReso.resolveTreatments;

  var _createExposureLogger = createExposureLogger({
    apiDomain: apiDomain,
    http: http,
    resolveTreatments: resolveTreatments,
    onError: onError
  }),
      logExposure = _createExposureLogger.logExposure,
      logExposures = _createExposureLogger.logExposures;

  return {
    logExposure: logExposure,
    logExposures: logExposures,
    resolve: resolveTreatments
  };
}